//Services
import { gen2Request } from 'src/services/gen_2_http_reqs';
//Types
import type { Device } from 'src/types/Device';
import type { SettingRequest } from 'src/types/requests/settings/setting';

/**
 * Retrieve the schedule list from a Gen 2 device via the "schedule.list" RPC.
 *
 * Returns the request result when successful (`isok` truthy), otherwise `null`.
 *
 * @param {Device} device Target device to query.
 * @returns {Promise<SettingRequest | null>} Resolves with the schedule list response or `null` on failure.
 *
 * @example
 * const res = await getScheduleList(device);
 * if (res?.isok) {
 *   // Access schedules in res.data (structure depends on device firmware)
 * }
 */
export const getScheduleList: (device: Device) => Promise<SettingRequest | null> = async (
	device: Device,
) => {
	try {
		const res = await gen2Request(device, 'schedule.list', {});
		if (res?.isok) {
			return res;
		} else {
			throw new Error('Failed to get schedule list');
		}
	} catch (err) {
		console.error('Error getting schedule list:', err);
	}
	return null;
};
